import React from 'react';
import { Input, Row } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { translate } from '@portal/services/i18n';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface IProps {
  code: string;
  setCode: (value: string) => void;
}

const OnboardingCreatePin = ({ code, setCode }: IProps) => {
  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

  const handleCode = (val: string) => {
    if (code.length === 6) {
      return;
    }
    const value = code.concat(val).replace(/\D/, '');
    setCode(value);
  };

  const deleteCode = () => {
    if (code.length > 0) {
      const value = code.slice(0, -1);
      setCode(value);
    }
  };

  const handleClean = () => {
    setCode('');
  };

  return (
    <div className="onboarding-create-pin">
      <div className="onboarding-create-pin__container">
        <ThemedText variant="h1" className="onboarding-create-pin__title">
          {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.PIN.TITLE')}
        </ThemedText>
        <ThemedText variant="body" className="confirmation-modal__instruction">
          {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.PIN.DESCRIPTION')}
        </ThemedText>
        <Row align="middle" justify="space-between">
          <ThemedText
            variant="body"
            className="confirmation-modal__electronic-password"
          >
            {translate('PAGES.AUTH.REGISTER.ONBOARD.PF.PIN.FORM.PIN')}
          </ThemedText>
          <ThemedText
            variant="body"
            className="confirmation-modal__clean"
            onClick={handleClean}
          >
            {translate('COMPONENTS.CONFIRMATION_MODAL.CLEAN')}
          </ThemedText>
        </Row>
        <div className="confirmation-modal__input-container" data-sentry-mask>
          <Input
            prefix={
              <div className="confirmation-modal__lock-icon">
                <LockOutlined />
              </div>
            }
            value={code}
            type="password"
            disabled
            maxLength={6}
          />
        </div>
        <div className="confirmation-modal__number-grid">
          {digits.map((digit) => (
            <ThemedText
              variant="body"
              key={digit}
              className="confirmation-modal__number-grid__digit"
              onClick={() => handleCode(digit)}
            >
              {digit}
            </ThemedText>
          ))}
          <ThemedText
            variant="body"
            className="confirmation-modal__number-grid__digit"
            onClick={deleteCode}
          >
            <img src="/assets/svg/ic_backspace.svg" alt="backspace image" />
          </ThemedText>
        </div>
      </div>
    </div>
  );
};

export default OnboardingCreatePin;
